import {Injectable} from '@angular/core';
import {CanActivate} from '@angular/router';

/**
 * Redirects the legacy /about route (now labelled "Our Story") to the external
 * Tikkun Olam Makers site. Returns false so Angular cancels the in-app
 * navigation while the browser leaves for the external URL.
 */
@Injectable({providedIn: 'root'})
export class AboutRedirectGuard implements CanActivate {
	canActivate(): boolean {
		window.location.href = 'https://www.tikkunolammakers.org/';
		return false;
	}
}
